export var createAdminApi = function (baseUrl, http) {
    var base = baseUrl + "/admin";
    var api = {
        appVersion: function () {
            return http.get(base + "/app/version");
        }
    };
    return api;
};
//# sourceMappingURL=index.js.map